import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {LayoutEngineService} from "@ispm-client/modules/layout-engine/services/layout-engine.service";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {Injectable} from "@angular/core";
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";
import {
  ILayoutConfigParams,
  LayoutConfigType
} from "@ispm-client/modules/layout-engine/interfaces/layout-config-params.interface";
import { ActivatedRoute, Router } from '@angular/router';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {AgregationService} from "@ispm-client/modules/aggregator/services";
import {IspmHttpClient} from "@ispm/core/services/ispm-http-client";
import {PermissionSchemaConstants} from "@ispm/shared/constants/permission-schema.constants";
import {AuthenticationService} from "@ispm/user/services/authentication.service";
import {map, switchMap} from 'rxjs/operators';
import {catchError} from "rxjs/operators";
import {of, Observable} from "rxjs";

@Injectable({ providedIn: 'root' })
export class resolvePanCancerForReports {
  constructor(private _http: HttpInterceptorService,
              private layoutEngineService: LayoutEngineService,
              private userActionCreateService: UserActionCreatorService,
              private navigationConfigService: NavigationConfigService,
              private activatedRoute: ActivatedRoute,
              private routerManagerService: RouterManagerService) {}
  resolve() {
    const params: ILayoutConfigParams = {
      application: this.navigationConfigService.getCurrentApplicationId(),
      type: LayoutConfigType.EventsPanel
    };
    const patientContext = this.activatedRoute.snapshot.data.patient;
    if (!patientContext) {
      this._http.get(`/patient/${this.routerManagerService.parameters.patientId}`)
        .map(data => {
          return data.json();
        }).subscribe(res => {
        this.userActionCreateService.updatePatient(res.id, res);
      });
    }
    return params;
  }
}

@Injectable({ providedIn: 'root' })
export class resolvePanCancerWithMrn {
  constructor(private _http: HttpInterceptorService,
              private layoutEngineService: LayoutEngineService,
              private activatedRoute: ActivatedRoute,
              private routerManagerService: RouterManagerService,
              private router: Router) {}
  resolve() {
    const params = this.routerManagerService.queryParameters;
    const mrn = params.mrn;
    if (params.patientId) {
      this.router.navigate(['Pancancer', params.patientId], {queryParams : {mrn : mrn}});
    } else if (mrn) {
      this._http.get(`/patient`, {identifier: mrn})
        .map(data => {
          return data.json();
        })
        .subscribe((res) => {
          if (res && res.length > 0) {
            const navigationExtras = {
              queryParams: { mrn: mrn },
              state: { patient: res[0] }
            };
            this.router.navigate(['Pancancer', params.patientId], navigationExtras);
          } else {
            // TODO: fix the router for the route pathologist home
            this.layoutEngineService.showErrorMessagePopup('Patient Not Found',
              'No matching patient details for the provided Medical Record Number found.',
              'ERRROR',
              'Pathologist');
          }
        });
    }
  }
}

@Injectable({ providedIn: 'root' })
export class resolvePanCancerWithPatientId {
  constructor(private activatedRoute: ActivatedRoute,
              private routerManagerService: RouterManagerService,
              private router: Router,
              private layoutEngineService: LayoutEngineService,
              private userActionCreateService: UserActionCreatorService,
              private aggregatorService: AgregationService,
              private _http: HttpInterceptorService,
              private ispmHttpClient: IspmHttpClient,
              private navigationConfigService: NavigationConfigService,
              private authService: AuthenticationService) {}
  resolve() {
    if (this.authService.doesUserHasPermission(PermissionSchemaConstants.getPermissionSchema('panCancerDashboardRead'))) {
      let patientContext = this.activatedRoute.snapshot.data.patient;
      let cancerType = '';
      let clinicalPhase = '';

      return new Observable(observer => {
        const conditionPayload = {
          'queries': [{
            'targetResource': 'Condition',
            'queryString': `context=${this.routerManagerService.parameters.patientId}&subResourceTypeCode=primary_cancer&categoryCode=primary&_fieldslist=cancer,clinicalPhase`
          }]
        };

        this.ispmHttpClient.post('bundleUtil/search', conditionPayload).subscribe(val => {
          const entry = val[0].response.entry;
          entry.forEach(element => {
            if (element.resource.cancer) { cancerType += element.resource.cancer.code + ','; }
            if (element.resource.clinicalPhase) { clinicalPhase += element.resource.clinicalPhase.code + ','; }
          });
          cancerType = cancerType.slice(0, cancerType.length - 1);
          clinicalPhase = clinicalPhase.slice(0, clinicalPhase.length - 1);

          if (!patientContext) {
            this._http.get(`/patient/${this.routerManagerService.parameters.patientId}`)
              .pipe(
                map(data => data.json()),
                catchError(() => of(null))
              )
              .subscribe(res => {
                patientContext = res;
                observer.next('patient context resolved');
                observer.complete();
              });
          } else {
            observer.next('patient context resolved');
            observer.complete();
          }
        });
      }).pipe(
        switchMap(() => {
          const params: ILayoutConfigParams = {
            application: this.navigationConfigService.getCurrentApplicationId(),
            type: LayoutConfigType.PanCancerDashboard,
            ...(clinicalPhase ? { clinicalPhase: clinicalPhase } : {}),
            ...(cancerType ? { cancerType: cancerType } : {})
          };
          if (cancerType) {
            patientContext['primaryCancer'] = cancerType;
          }

          this.userActionCreateService.updatePatient(patientContext.id, patientContext);
          return of(params);
        }),
        catchError(() => {
          // TODO: fix the router for the route pathologist home
          this.layoutEngineService.showErrorMessagePopup(
            'Patient Not Found',
            'No matching patient details for the provided Patient Identifier found.',
            'ERROR',
            'Pathologist'
          );
          return of(null);
        })
      );
    } else {
      // TODO: fix the router for the route pathologist home
      this.layoutEngineService.showErrorMessagePopup(
        'Access Denied',
        'You don`t currently have permission to access pan cancer dashboard. Please contact administrator.',
        'ERROR',
        'Pathologist'
      );
      return of(null);
    }
  }
}
